import React, { useState, useRef } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../../util/reactIntl';

import { OutsideClickHandler } from '../../../../../components';

import css from './FilterListingTypes.module.css';

const ListingTypeDropdown = ({ input, className, rootClassName, listingTypes, alignLeft }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [hasSelected, setHasSelected] = useState(false);
  const optionRefs = useRef([]);
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
    if (!isOpen) {
      // reset the index used to navigate menu items using keyboard when the menu is closed
      setActiveIndex(-1);
    }
  };

  const handleOptionClick = optionId => {
    const value = optionId === 'all-categories' ? '' : optionId;
    input.onChange(value);
    setHasSelected(true);
    setIsOpen(false);
  };

  // keydown handling when navigating menu using keyboard
  const handleKeyDown = e => {
    if (!isOpen) {
      if (e.key === 'ArrowDown' || e.key === 'Enter') {
        e.preventDefault();
        setIsOpen(true);
        setActiveIndex(0);
      }
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveIndex(prev => {
        if (prev < allOptions.length - 1) {
          return prev + 1;
        }
        return prev;
      });
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex(prev => {
        if (prev > 0) {
          return prev - 1;
        }
        return prev;
      });
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const selected = allOptions[activeIndex];
      if (selected) handleOptionClick(selected.listingType);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setIsOpen(false);
    }
  };

  const selectedListingType = listingTypes.find(
    listingType => listingType.listingType === input.value
  );

  // Replace
  // const labelText = selectedListingType ? (
  //   selectedListingType.name
  // ) : hasSelected && input.value === '' ? (
  //   <FormattedMessage id="PageBuilder.SearchCTA.CategoryFilter.selectAll" />
  // ) : (
  //   <FormattedMessage id="PageBuilder.SearchCTA.CategoryFilter.placeholder" />
  // );

  // With
  const labelText = selectedListingType ? (
    selectedListingType.label
  ) : hasSelected && input.value === '' ? (
    <FormattedMessage id="PageBuilder.SearchCTA.CategoryFilter.selectAll" />
  ) : (
    <FormattedMessage id="PageBuilder.SearchCTA.listingFilter.placeholder" />
  );

  const rootClass = rootClassName || css.root;
  const classes = classNames(rootClass, className);

  // append the "all categories" option to the list of categories
  const allOptions = [...listingTypes];

  // const optionRefs = useRef([]);

  return (
    <OutsideClickHandler className={classes} onOutsideClick={() => setIsOpen(false)}>
      <div className={css.dropdownContainer}>
        <div
          role="combobox"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          aria-owns="category-listbox"
          aria-controls="category-listbox"
          tabIndex={0}
          onClick={toggleDropdown}
          onKeyDown={handleKeyDown}
          className={classNames(css.toggleButton, {
            [css.unselected]: !hasSelected && !selectedListingType && !isOpen,
            [css.placeholderOpened]: isOpen && !hasSelected,
          })}
        >
          <span className={css.dropdownItem}>{labelText}</span>
          <span className={classNames(css.chevron, isOpen && css.isOpen)} />
        </div>

        {isOpen && (
          <ul
            className={classNames(css.dropdownContent, {
              [css.alignLeft]: alignLeft,
            })}
            role="listbox"
            id="category-listbox"
          >
            {/* Replace */}
            {/* {allOptions.map(({ id, name }, index) => {
              const isSelected =
                id === input.value || (id === 'all-categories' && input.value === '');
              const isActive = index === activeIndex;
              return (
                <li
                  key={id}
                  ref={option => (optionRefs.current[index] = option)}
                  className={classNames(css.option, {
                    [css.activeOption]: isActive,
                  })}
                  role="option"
                  aria-selected={isSelected}
                  onClick={() => handleOptionClick(id)}
                >
                  <span
                    className={isSelected ? css.dropdownItemBorderSelected : css.dropdownItemBorder}
                  />
                  {name}
                </li>
              );
            })} */}

            {/* With */}
            {allOptions.map((option, index) => {
              const isSelected =
                option.listingType === input.value ||
                (option.id === 'all-categories' && input.value === '');
              const isActive = index === activeIndex;

              const displayName =
                option.id === 'all-categories' ? (
                  <FormattedMessage id="PageBuilder.SearchCTA.CategoryFilter.selectAll" />
                ) : (
                  option.label
                );

              return (
                <li
                  key={option.id}
                  ref={el => (optionRefs.current[index] = el)}
                  className={classNames(css.option, { [css.activeOption]: isActive })}
                  role="option"
                  aria-selected={isSelected}
                  onClick={() => handleOptionClick(option.listingType)}
                >
                  <span
                    className={isSelected ? css.dropdownItemBorderSelected : css.dropdownItemBorder}
                  />
                  {displayName}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

// Final Form wrapper
const FilterListingTypes = props => {
  // const { className, rootClassName, ...rest } = props;
  const { className, rootClassName, listingTypes, alignLeft } = props;
  return (
    <Field
      // {...rest}
      name="pub_listingType"
      component={ListingTypeDropdown}
      listingTypes={listingTypes}
      className={className}
      rootClassName={rootClassName}
      alignLeft={alignLeft}
    />
  );
};

export default FilterListingTypes;
